<template>
  <section class="pre-view-driver" @click="driver.reStart">
    <i class="gattaran-wentifankui"></i>
    <span>{{ $t('Gattaran_Homepage__uCVu' /*查看引导*/) }}</span>
  </section>
</template>
<script>
import useDriver from '@/plugins/driver/driver';
// import { onMounted } from 'vue';
export default {
  setup() {
    const driver = useDriver();
    // onMounted(() => {
    //   driver.start();
    // });
    return {
      driver,
    };
  },
};
</script>
<style lang="scss" scoped>
.pre-view-driver {
  cursor: pointer;
  position: fixed;
  font-size: 14px;
  color: #fff;
  right: 20px;
  bottom: 20px;
  z-index: 999;
  height: 40px;
  background: #282b33;
  border-radius: 20px;
  text-align: center;
  line-height: 40px;
  padding: 0 20px;
  i,
  span {
    vertical-align: middle;
  }
  i {
    margin-right: 3px;
  }
}
</style>
